import type { ConnectorManifest } from "@io-spoke/contracts/integrations";
import azureDevopsLogo from "devicon/icons/azuredevops/azuredevops-original.svg";
import salesforceLogo from "devicon/icons/salesforce/salesforce-original.svg";
import slackLogo from "devicon/icons/slack/slack-original.svg";
import type { SimpleIcon } from "simple-icons";
import { siGithub, siHubspot, siIntercom, siJira, siLinear, siShortcut, siZendesk } from "simple-icons";

const icons: Partial<Record<ConnectorManifest["id"], SimpleIcon>> = {
  github: siGithub,
  hubspot: siHubspot,
  intercom: siIntercom,
  jira: siJira,
  linear: siLinear,
  shortcut: siShortcut,
  zendesk: siZendesk,
};

const imageLogos: Partial<Record<ConnectorManifest["id"], string>> = {
  azure_devops: azureDevopsLogo,
  io_spoke_demo: "/brand/io-spoke-mark-square-color.png",
  salesforce: salesforceLogo,
  slack: slackLogo,
};

export function ProviderLogo({ provider, className = "h-10 w-10" }: { provider: ConnectorManifest; className?: string }) {
  const icon = icons[provider.id];
  const imageLogo = imageLogos[provider.id];
  return <div className={`flex shrink-0 items-center justify-center rounded-lg border bg-white p-2 ${className}`} aria-hidden="true">
    {provider.id === "monday" ? <svg viewBox="0 0 24 24" className="h-full w-full" focusable="false"><path d="M4.2 15.8 9.8 4.6" stroke="#f62b54" strokeWidth="3.6" strokeLinecap="round"/><path d="m10.4 15.8 5.5-11.2" stroke="#ffcb00" strokeWidth="3.6" strokeLinecap="round"/><path d="m16.5 15.8 3.1-6.2" stroke="#00ca72" strokeWidth="3.6" strokeLinecap="round"/><circle cx="18.1" cy="19.2" r="1.8" fill="#579bfc"/></svg>
      : icon ? <svg viewBox="0 0 24 24" className="h-full w-full" fill={`#${icon.hex}`} focusable="false"><path d={icon.path}/></svg>
      : imageLogo ? <img src={imageLogo} alt="" className="h-full w-full object-contain" />
        : <span className="text-xs font-semibold text-foreground">{provider.name.slice(0, 2).toUpperCase()}</span>}
  </div>;
}
